import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { authApi } from './authApi';
import { useAuthStore } from '@/store/authStore';
import { paths } from '@/routes/paths';

/** High-level auth state + actions for app components. */
export function useAuth() {
  const user = useAuthStore((s) => s.user);
  const status = useAuthStore((s) => s.status);
  const sessionExpired = useAuthStore((s) => s.sessionExpired);
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const logout = useCallback(
    async (options?: { allDevices?: boolean }) => {
      try {
        if (options?.allDevices) await authApi.logoutAll();
        else await authApi.logout();
      } catch {
        // Even if the network call fails, clear locally — the token is short-lived.
      } finally {
        useAuthStore.getState().clear('logout');
        queryClient.clear();
        navigate(paths.login, { replace: true });
      }
    },
    [navigate, queryClient],
  );

  return {
    user,
    status,
    sessionExpired,
    isAuthenticated: status === 'authenticated' && !!user,
    logout,
  };
}
